import styled from 'styled-components';
import { Shape } from '../../assets';
import '../../animation/boundInDown.css';
const Container = ({ children, type }) => {
  return (
    <ContainerStyle>
      <Shape style={{ bottom: 0, left: 0 }} className="animate__boundInDown" type={type} />
      <Shape
        id="shape2"
        style={{ top: '8px', left: '25%', width: '2pc' }}
        className="animate__boundInDown"
        type={type}
      />
      <Shape
        id="shape3"
        style={{ bottom: '8px', right: '25%', width: '2pc' }}
        className="animate__boundInDown"
        type={type}
      />
      <Shape
        id="shape4"
        style={{ top: '28px', right: '25%', width: '4pc' }}
        className="animate__boundInDown"
        type={type}
      />
      {children}
    </ContainerStyle>
  );
};

export default Container;
const ContainerStyle = styled.div`
  display: flex;
  min-height: 100vh;
  position: relative;
`;
